import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=113f490b&scoped=true"
import script from "./Compass.vue?vue&type=script&lang=js"
export * from "./Compass.vue?vue&type=script&lang=js"
import style0 from "./Compass.vue?vue&type=style&index=0&id=113f490b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113f490b",
  null
  
)

export default component.exports